import React from 'react'

import FailPageHeadingIcon from '../../assets/icons/fail-page-heading-icon.svg'
import ButtonBackToPartner from 'components/Buttons/ButtonBackToPartner/ButtonBackToPartner'
import useTextContents from 'common/hooks/useTextContents'
import { BACK_TO_PARTNER_LINK_TYPES } from 'components/Buttons/ButtonBackToPartner/BackToPartnerButtonProps'

import './FailPageStyles.scss'


/**
 * Komponent obsługujący stronę "Decyzja negatywna" 
*/
const FailPage = (): JSX.Element => {

   const failPageTextContents = useTextContents()

   return (
      <div className='fail-page-outer-wrapper'>
         <img className='fail-page-heading-icon' src={FailPageHeadingIcon} alt='decyzja negatywna'/>
         <h1 className='fail-page-heading-text'>{failPageTextContents('failPage.header')}</h1>
         <div className='fail-page-description-text-wrapper'>
            <p>{failPageTextContents('failPage.mainContent.part1')}</p>
            <p>{failPageTextContents('failPage.mainContent.part2')}</p>
         </div>
         <ButtonBackToPartner linkType={BACK_TO_PARTNER_LINK_TYPES.FAILURE} />
      </div>
   )
}

export default FailPage